// 最后生成时间：10/23/2018 14:16:33
import { FileInfo } from './FileInfo';
import { ListResultDtoOfFileInfo } from './ListResultDtoOfFileInfo';
import { throwException } from './Utilities';
var FileServiceProxy = /** @class */ (function () {
    function FileServiceProxy(baseUrl) {
        this.beforeSend = undefined;
        this.jsonParseReviver = undefined;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    FileServiceProxy.prototype.download = function (id) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.downloadWithCallbacks(id, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    FileServiceProxy.prototype.downloadWithCallbacks = function (id, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/file/download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        abp.ajax.request({
            url: url_,
            method: "get",
            headers: {}
        }).then(function (xhr) {
            _this.processDownloadWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processDownloadWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    FileServiceProxy.prototype.processDownloadWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processDownload(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    FileServiceProxy.prototype.processDownload = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            return;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return;
    };
    /**
     * @param associateId (optional)
     * @param associateType (optional)
     * @param description (optional)
     * @param md5 (optional)
     * @param file (optional)
     * @return Success
     */
    FileServiceProxy.prototype.upload = function (associateId, associateType, description, md5, file) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.uploadWithCallbacks(associateId, associateType, description, md5, file, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    FileServiceProxy.prototype.uploadWithCallbacks = function (associateId, associateType, description, md5, file, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/file/upload";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (associateId !== null && associateId !== undefined)
            content_.append("associateId", associateId.toString());
        if (associateType !== null && associateType !== undefined)
            content_.append("associateType", associateType.toString());
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());
        if (md5 !== null && md5 !== undefined)
            content_.append("md5", md5.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        abp.ajax.request({
            url: url_,
            method: "post",
            data: content_,
            mimeType: "multipart/form-data",
            contentType: false,
            headers: {
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processUploadWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processUploadWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    FileServiceProxy.prototype.processUploadWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processUpload(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    FileServiceProxy.prototype.processUpload = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileInfo.fromJS(resultData200) : new FileInfo();
            return result200;
        }
        else if (status === 401) {
            var _responseText = xhr.responseText;
            return throwException("A server error occurred.", status, _responseText, _headers, xhr.data);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    /**
     * @param associateType (optional)
     * @param associateId (optional)
     * @return Success
     */
    FileServiceProxy.prototype.all = function (associateType, associateId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.allWithCallbacks(associateType, associateId, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    FileServiceProxy.prototype.allWithCallbacks = function (associateType, associateId, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/file/all?";
        if (associateType !== undefined)
            url_ += "associateType=" + encodeURIComponent("" + associateType) + "&";
        if (associateId !== undefined)
            url_ += "associateId=" + encodeURIComponent("" + associateId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        abp.ajax.request({
            url: url_,
            method: "get",
            headers: {
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    FileServiceProxy.prototype.processAllWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    FileServiceProxy.prototype.processAll = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfFileInfo.fromJS(resultData200) : new ListResultDtoOfFileInfo();
            return result200;
        }
        else if (status === 401) {
            var _responseText = xhr.responseText;
            return throwException("A server error occurred.", status, _responseText, _headers, xhr.data);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    /**
     * @param input (optional)
     * @return Success
     */
    FileServiceProxy.prototype.check = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.checkWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    FileServiceProxy.prototype.checkWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/file/check";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: "post",
            data: content_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processCheckWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processCheckWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    FileServiceProxy.prototype.processCheckWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processCheck(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    FileServiceProxy.prototype.processCheck = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileInfo.fromJS(resultData200) : new FileInfo();
            return result200;
        }
        else if (status === 401) {
            var _responseText = xhr.responseText;
            return throwException("A server error occurred.", status, _responseText, _headers, xhr.data);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    return FileServiceProxy;
}());
export { FileServiceProxy };
